import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toAbsoluteUrl } from '../../assets/helpers/AssetHelpers';
import './subHeader.css';
import useReRouteHook from '../../assets/hooks/useReRouteHook';
import { BreadcrumbLoader } from '../common/JainamLoader/JainamLoader';
interface SubHeaderProps {
	childCategoryName: string;
	mainCategoryName: string;
}

const SubHeader: React.FC<SubHeaderProps> = ({ childCategoryName, mainCategoryName }) => {
	const { category_name, child_category_name } = useParams();
	const navigate = useNavigate();

	const { reRouteButtonRenderer } = useReRouteHook();
	if (!category_name || !child_category_name) {
		navigate('/no-results-found');
		return null;
	}
	return (
		<div className="d-flex px-0">
			<div className="col-lg-12 col-12">
				<nav aria-label="breadcrumb" className="px-0 px-md-3 px-lg-0">
					<ol className="breadcrumb cursor-pointer bw_med fs-sm-14 mt-lg-0 mb-0">
						<li className="breadcrumb-item active" aria-current="page">
							{reRouteButtonRenderer({
								url: '/',
								classes: 'color1 in_reg border-0 bg-transparent ps-0',
								nameText: 'Home',
							})}
						</li>
						<li className="breadcrumb-item">
							{mainCategoryName ? reRouteButtonRenderer({
								url: `/category/${category_name}/${child_category_name}`,
								classes: 'color1 in_reg border-0 bg-transparent',
								nameText: mainCategoryName,
							}) : <BreadcrumbLoader />}
						</li>
						<li className="breadcrumb-item">
							{childCategoryName ? reRouteButtonRenderer({
								url: `/category/${category_name}/${child_category_name}`,
								classes: 'color28 in_reg border-0 bg-transparent',
								nameText: childCategoryName,
							}) : <BreadcrumbLoader />}
						</li>
					</ol>
				</nav>
			</div>
		</div>
	);
};

export default SubHeader;
